// @index('./item_types/(?!index|_)*.js', f => `import ${f.name} from '@components/action_menu/item_types/${f.name}';`)
import ActionMenuBaseItem from "@components/action_menu/item_types/ActionMenuBaseItem";
import ActionMenuClipboardCopyItem from "@components/action_menu/item_types/ActionMenuClipboardCopyItem";
import ActionMenuRecordDeletionItem from "@components/action_menu/item_types/ActionMenuRecordDeletionItem";
import ActionMenuDividerItem from "@components/action_menu/item_types/ActionMenuDividerItem";
import ActionMenuDuplicateRecordItem from "@components/action_menu/item_types/ActionMenuDuplicateRecordItem";
import ActionMenuFavoritedPageToggleItem from "@components/action_menu/item_types/ActionMenuFavoritedPageToggleItem";
import ActionMenuLinkItem from "@components/action_menu/item_types/ActionMenuLinkItem";
import ActionMenuModalItem from "@components/action_menu/item_types/ActionMenuModalItem";
import ActionMenuOperationItem from "@components/action_menu/item_types/ActionMenuOperationItem";
import ActionMenuReloadPageItem from "@components/action_menu/item_types/ActionMenuReloadPageItem";
// @endindex

const ITEM_TYPE_COMPONENTS = {
  base: ActionMenuBaseItem,
  clipboard_copy: ActionMenuClipboardCopyItem,
  record_deletion: ActionMenuRecordDeletionItem,
  divider: ActionMenuDividerItem,
  duplicate_record: ActionMenuDuplicateRecordItem,
  favorited_page_toggle: ActionMenuFavoritedPageToggleItem,
  link: ActionMenuLinkItem,
  modal: ActionMenuModalItem,
  operation: ActionMenuOperationItem,
  reload_page: ActionMenuReloadPageItem,
};

export default function ActionMenuItem(props) {
  const {
    type,
  } = props;

  const ItemComponent = ITEM_TYPE_COMPONENTS[type];
  if (!ItemComponent) return null;

  return (
    <ItemComponent {...props} />
  );
}
